import React from 'react';

export const AuditTrailModal = ({
  isOpen,
  onClose,
  auditList = [],
  loading = false,
  testName = '',
  tests = [],
  activeTestId = null,
  onChangeTest = null,
}) => {
  if (!isOpen) return null;

  return (
    <div className="path-modal-overlay">
      <div className="path-modal-content path-modal-lg">
        <div className="path-modal-header">
          <div className="title-box">
            <h3>🔍 Parameter Delta Audit Trail</h3>
            <span className="sub-title">{testName || 'Investigation Audit'}</span>
          </div>
          <button type="button" className="path-close-btn" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        {tests && tests.length > 1 && (
          <div className="path-audit-test-switcher" style={{ display: 'flex', gap: '8px', padding: '10px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', overflowX: 'auto' }}>
            <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', alignSelf: 'center', marginRight: '4px' }}>Select Test:</span>
            {tests.map((t) => (
              <button
                key={t.testId}
                type="button"
                className={`path-audit-test-btn ${t.testId === activeTestId ? 'active' : ''}`}
                style={{
                  padding: '5px 12px',
                  fontSize: '12px',
                  fontWeight: t.testId === activeTestId ? 700 : 500,
                  borderRadius: '20px',
                  border: t.testId === activeTestId ? '1px solid #2563eb' : '1px solid #cbd5e1',
                  background: t.testId === activeTestId ? '#2563eb' : '#ffffff',
                  color: t.testId === activeTestId ? '#ffffff' : '#334155',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  whiteSpace: 'nowrap'
                }}
                onClick={() => onChangeTest && onChangeTest(t.testId)}
              >
                {t.investigationName || t.itemName || `Test #${t.testId}`}
              </button>
            ))}
          </div>
        )}

        <div className="path-modal-body">
          {loading ? (
            <div className="path-loading-box" style={{ padding: '40px 20px', textAlign: 'center' }}>
              <div className="path-spinner" style={{ margin: '0 auto 12px' }} />
              <span style={{ fontSize: '13px', color: '#64748b' }}>⏳ Loading parameter modification history...</span>
            </div>
          ) : auditList.length === 0 ? (
            <div className="path-empty-audit">
              <div className="icon">📋</div>
              <h4>No parameter modifications found</h4>
              <p>This test currently retains its baseline findings and has not undergone parameter delta edits or post-approval clinical revisions.</p>
            </div>
          ) : (
            <div className="path-table-wrapper">
              <div className="path-audit-count-banner" style={{ marginBottom: '12px', fontSize: '12px', color: '#475569', fontWeight: 600 }}>
                Showing {auditList.length} recorded parameter modification{auditList.length === 1 ? '' : 's'} with delta tracking
              </div>
              <table className="path-table">
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>Parameter</th>
                    <th>Type</th>
                    <th>Previous Value</th>
                    <th>New Value</th>
                    <th>Modified By</th>
                    <th>Reason / Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {auditList.map((entry, idx) => {
                    const isRevision = entry.actionType?.toLowerCase().includes('revision') ||
                      entry.changeReason?.toLowerCase().includes('revision');

                    return (
                      <tr key={entry.id || idx}>
                        <td className="path-cell-muted" style={{ whiteSpace: 'nowrap', fontSize: '11px' }}>
                          {entry.changedDate
                            ? new Date(entry.changedDate).toLocaleString([], {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                              })
                            : '—'}
                        </td>
                        <td className="path-cell-bold">
                          {entry.labObservationName || entry.labObservationId}
                        </td>
                        <td>
                          <span className={`path-audit-badge ${isRevision ? 'audit-badge-revision' : 'audit-badge-edit'}`}>
                            {entry.actionType || (isRevision ? 'Clinical Revision' : 'Pre-Approval Edit')}
                          </span>
                        </td>
                        <td>
                          <span className="path-val-old">{entry.oldValue !== null && entry.oldValue !== undefined ? entry.oldValue : '—'}</span>
                        </td>
                        <td>
                          <span className="path-val-new">{entry.newValue !== null && entry.newValue !== undefined ? entry.newValue : '—'}</span>
                        </td>
                        <td>
                          <span className="path-user-badge">👤 {entry.changedBy || 'Admin'}</span>
                        </td>
                        <td className="path-cell-muted" style={{ fontSize: '12px', maxWidth: '220px' }}>
                          {entry.changeReason || (isRevision ? 'Clinical revision' : 'Pre-approval modification')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="path-modal-footer">
          <button type="button" className="path-btn path-btn-secondary" onClick={onClose}>
            Close Audit Trail
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuditTrailModal;
